/**
 * @generated SignedSource<<ee55aa91ee6fb8cfe9927f53e85c3fc1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TeamType = "CHECKOUT" | "FLOOR";
import { FragmentRefs } from "relay-runtime";
export type TeamNavigator_team$data = {
  readonly id: string;
  readonly name: string;
  readonly type: TeamType;
  readonly " $fragmentSpreads": FragmentRefs<"TeamHeader_team">;
  readonly " $fragmentType": "TeamNavigator_team";
};
export type TeamNavigator_team$key = {
  readonly " $data"?: TeamNavigator_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamNavigator_team">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamNavigator_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamHeader_team"
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "b18c118ad8d7abb09a1a2764ce80972f";

export default node;
